document.addEventListener('DOMContentLoaded', function() {
  // Initialize lazy loading for containers
  initLazyLoading();
});

function initLazyLoading() {
  // Lazy loading implementation
  if ('IntersectionObserver' in window) {
    const lazyContainers = document.querySelectorAll('[data-lazy-container]');
    
    lazyContainers.forEach(lazyContainer => {
      if (!lazyContainer) return;
      
      const lazyItems = lazyContainer.querySelectorAll('[data-lazy-item]');
      
      const lazyLoadObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const item = entry.target;
            
            // Handle lazy images
            const lazyImage = item.querySelector('.lazy-image');
            if (lazyImage && lazyImage.dataset.src) {
              lazyImage.src = lazyImage.dataset.src;
              lazyImage.removeAttribute('data-src');
            }
            
            // Handle lazy videos
            const lazyVideo = item.querySelector('.lazy-video');
            if (lazyVideo && lazyVideo.dataset.src) {
              lazyVideo.src = lazyVideo.dataset.src;
              lazyVideo.setAttribute('autoplay', '');
              lazyVideo.removeAttribute('data-src');
            }
            
            // Stop observing after loading
            observer.unobserve(item);
          }
        });
      }, {
        rootMargin: '100px 0px', // Load when within 100px of viewport
        threshold: 0.1
      });
      
      // Start observing each item
      lazyItems.forEach(item => {
        lazyLoadObserver.observe(item);
      });
    });
  } else {
    // Fallback for browsers without IntersectionObserver support
    const lazyImages = document.querySelectorAll('.lazy-image');
    lazyImages.forEach(img => {
      if (img.dataset.src) {
        img.src = img.dataset.src;
      }
    });
    
    const lazyVideos = document.querySelectorAll('.lazy-video');
    lazyVideos.forEach(video => {
      if (video.dataset.src) {
        video.src = video.dataset.src;
        video.setAttribute('autoplay', '');
      }
    });
  }
} 